type CompleteProps = {
  border?: string;
};

export function Completed({ border = 'currentColor' }: CompleteProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 100 100"
    >
      <circle cx="50" cy="50" r="45" stroke={border} strokeWidth="8" fill="none" />
      <path
          d="M30 50 L45 70 L70 30"
          stroke="currentColor"
          strokeWidth="8"
          fill="none"
      />
    </svg>
  );
}
